import actions from './actions'
const initState = {
  CHANGE_LANG: true
}

export default function loadingReducer (state = initState, action) {
  switch (action.type) {
    case actions.UPDATE_LOADING_STATES:
      return {
        ...state,
        ...action.target
      }
    case actions.RESET_LOADING_STATES:
      const { payload } = action
      if (payload && Array.isArray(payload)) {
        let stateToBeReset = {}
        payload.forEach(key => {
          stateToBeReset[key] = initState[key]
        })
        return {
          ...state,
          ...stateToBeReset
        }
      } else {
        return {
          ...state
        }
      }
    default:
      return state
  }
}
